import React from 'react'
import emblem from '../assets/images/pt-emblem.svg'
import heart from '../assets/images/pt-heart-icon.svg'
import yifLogo from '../assets/images/yusuf-islam-f-b-w.svg'
import csLogo from '../assets/images/cs-logo.png'
import facebook from '../assets/images/facebook-logo.svg'
import twitter from '../assets/images/twitter-logo.svg'
import instagram from '../assets/images/instagram-logo.svg'
import { Link } from "gatsby"

const Footer = () => {
    return (
        <footer>
            <div className="footer">
                <div className="footer-first-item">
                    {/* <div className="footer-center">
                        <div className="empty-div" />
                        <div className="empty-div" />
                    </div> */}
                    {/* <div className="footer-center">
                        <div className="empty-div" />
                        <div className="footer-right-bottom-first">
                            <p>If you would like to</p>
                            <Link to="/contribute?num=1" className="btn btn-primary footer-contribute-button">
                                <span>
                                    contribute
                                </span>
                                <span style={{ alignSelf: "end" }}>
                                    <img width={27} height={27} src={heart} alt="heart-icon" />
                                </span>
                            </Link>
                        </div>
                    </div> */}
                    <div className="footer-center">
                        <div className="empty-div" />
                        <div className="empty-div" />
                    </div>
                    <div className="footer-center">
                        <div className="footer-left">
                            <div className="footer-socialIcons" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '16px' }}>
                                <div className="footer-logo">
                                    <img
                                        src={emblem}
                                        alt="pt-emblem"
                                        width={132.703}
                                        height={42.766}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                    <p className="footer-emblem-slogan" style={{ margin: 0 }}>"the world as one"</p>
                                    <p className="footer-comment footer-second-comment" style={{ margin: 0 }}>Peace Train is a Yusuf Islam Project</p>
                                </div>
                            </div>
                        </div>
                        <div className="footer-right">
                            <div className="footer-right-bottom-second">
                                <div className="footer-right-bottom-second-firstColumn">
                                </div>
                                <div className="footer-right-bottom-second-secondColumn">
                                    <p style={{ marginTop: 0}}>Under the Patronage of</p>
                                    <img src={csLogo} alt="Catstevens" height="74vh"></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-center">
                        <div className="empty-div" />
                        <div className="empty-div" />
                    </div>
                </div>
            </div>
            <div className="footer-terms-of-use">
                <p><Link to="/privacy-policy">Privacy Policy</Link> | © 2021 Yusuf Islam Foundation</p>
            </div>
        </footer>
    )
}

export default Footer
